<template>
  <div class="ring-timer-container">
    <template v-if="!isEdit || isCorporate">
      <div class="call-route my-4 d-flex flex-column">
        <span class="route-ring mx-4 pb-4 hb-font-body">
          Ring Time before Final Call Route:
          <strong>{{ totalTime }} Seconds</strong>
        </span>
        <span class="mx-4 hb-font-body">
          Primary Group only:
          <strong>{{ primaryGroupTime }} Seconds</strong>
        </span>
        <span class="mx-4 hb-font-body">
          Primary and Secondary Groups:
          <strong>{{ primarySecondaryGroupTime }} Seconds</strong>
        </span>
      </div>
    </template>

    <hb-form
      v-else-if="isEdit && !isCorporate"
      class="ring-times-form"
      label="Ring Time"
      :disable-save="pgoError"
      full
    >
      <template>
        <span class="hb-text-light hb-font-body">
          Set the number of seconds the system will ring before the Final Call Route (voicemail).
        </span>
        <br/>
        <span class="hb-text-light hb-font-body">*Total ring time cannot exceed 30 Seconds</span>
        <!-- RTFCR -->
        <div class="input-flex d-flex py-4">
          <span class="hb-font-body pr-2">Ring Time before Final Call Route:</span>
          <HbTextField
            condensed
            box
            small
            v-model="totalTime"
            v-validate="'required|numeric|max_value:30|min_value:10'"
            data-vv-scope="default"
            data-vv-name="ring_time_final"
            data-vv-as="Total Ring Time"
            :error="errors.has('default.ring_time_final')"
            placeholder="1"
            :alignRight="true"
          />
          <span class="hb-font-body-medium">Seconds</span>
        </div>

        <span class="hb-text-light hb-font-body">Set the number of seconds the system will ring for Primary and Secondary groups.</span>
        <br/>
        <span class="hb-text-light hb-font-body">*Primary group ring time cannot exceed Total Ring Time.</span>
        <!-- PGO -->
        <div class="d-flex mt-4 align-items-start flex-column">
          <div class="d-flex">
            <span class="hb-font-body pr-2">Primary Group only:</span>
            <HbTextField
              condensed
              box
              small
              v-model="primaryGroupTime"
              v-validate="'required|numeric|max_value:30|min_value:0'"
              data-vv-scope="default"
              data-vv-name="ring_time_primary"
              data-vv-as="Primary Group Ring Time"
              :error="errors.has('default.ring_time_primary') || pgoError"
              placeholder="0"
              :alignRight="true"
            />
            <span class="hb-font-body-medium">Seconds</span>
          </div>
        </div>

        <!-- PSG -->
        <div class="d-flex">
          <span class="hb-font-body pr-2">Primary and Secondary Groups:</span>
          <span class="hb-font-body-medium pr-1">{{ primarySecondaryGroupTime }}</span>
          <span class="hb-font-body-medium">Seconds</span>
        </div>
      </template>
    </hb-form>
  </div>
</template>

<script>
import { property } from "lodash";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RingTimes",
  props: {
    tab: {
      type: String,
      default: "tab-Corporate"
    },
    isCorporate: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    property_id:{
      type: String,
      default:null
    }
  },
  data() {
    return {
      totalTime: 30,
      primaryGroupTime: 10,
      isFormValid: false,
      pgoError: false
    };
  },
  computed: {
    ...mapGetters({
      ringTime: "charmSubscriptionStore/ringTime"
    }),
    primarySecondaryGroupTime() {
      const diff = this.totalTime - this.primaryGroupTime;
      return diff >= 0 ? diff : 0;
    }
  },
  methods: {
    resetData() {
        this.totalTime = 30;
        this.primaryGroupTime = 10;
        this.pgoError = false;
    },
    resetToOriginal() {
      if (this.tab === 'tab-Corporate' && this.ringTime?.corporate?.id) {
        this.totalTime = this.ringTime.corporate.total_time ?? 30;
        this.primaryGroupTime = this.ringTime.corporate.primary_group_time ?? 10;
      } else if (this.ringTime?.property) {
        this.totalTime = this.ringTime.property.total_time ?? 30;
        this.primaryGroupTime = this.ringTime.property.primary_group_time ?? 10;
      }
      this.pgoError = false;
    },
      async triggerSave() {
        const isValid = await this.$validator.validateAll('default');

        const total = Number(this.totalTime);
        const primary = Number(this.primaryGroupTime);
        const pgoError = primary > total;

        this.errors.remove('ring_time_primary');

        if (pgoError) {
          this.errors.add({
            field: 'ring_time_primary',
            scope: 'default',
            msg: 'Primary Group ring time cannot exceed Total Ring Time.'
          });
        }

        if (!isValid || pgoError) {
          return;
        }
        if (!this.pgoError && isValid) {
          this.$emit("save", {
            total_time: Number(this.totalTime),
            primary_group_time: Number(this.primaryGroupTime),
            primary_secondary_group_time: Number(this.totalTime) - Number(this.primaryGroupTime),
          });
        }
      },
    async getRingTime(){
      let query = {}
      if(this.property_id){
        query.property_id = this.property_id
      }
      await this.$store.dispatch('charmSubscriptionStore/getRingTime',query);
    }

  },
    watch: {
        tab: async function (newTab, oldTab) {
          this.resetToOriginal();
          await this.getRingTime();
        },
        ringTime: {
          immediate: true,
          handler(data) {
              if(this.tab == 'tab-Corporate' && data?.corporate?.id){
                  this.totalTime = data?.corporate?.total_time ?? 30
                  this.primaryGroupTime = data?.corporate?.primary_group_time ?? 10
              }else{
                if(data?.property){
                  this.totalTime = data?.property?.total_time ?? 30
                  this.primaryGroupTime = data?.property?.primary_group_time ?? 10
                }
              }
          }
        }
    },
};
</script>

<style scoped>
    .ring-times-form ::v-deep .hb-aviary-form-label-150 {
        display: none !important;
    }
    .ring-times-form ::v-deep .v-divider {
        display: none;
    }
    .route-ring {
        border-bottom: 1px solid #DFE3E8;
    }
    .call-route {
        gap: 15px;
    }
    .input-flex {
        border-bottom: 1px solid #DFE3E8;
    }
    .text-danger {
        color: #d9534f;
        font-size: 0.875rem;
    }
</style>
